import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TripContext } from 'contexts';
import dateFormat from "dateformat";
import React, { FC, useContext } from 'react';
import { Trip } from 'services/types';
import './to-and-from.scss';

type Props = {
  loadId: number
}


export const ToAndFrom: FC<Props> = ({ loadId }) => {
  const na = 'N/A'
  const tripContext = useContext(TripContext)
  const load: Trip = tripContext.trips.find(t => t.id === loadId) ?? {} as Trip


  let dueOutFormatted = (load && load.dueOut) && dateFormat(load.dueOut, 'mm/dd hh:MMtt');
  let firstAppointmentFormatted = (load && load.firstAppointmentTime) && dateFormat(load.firstAppointmentTime, 'mm/dd hh:MMtt');

  return (
    <div className={'to-and-from-card'}>
      <div className={'to-and-from-row'}>
        <div className={'to-and-from-leftcolumn'}>
          <FontAwesomeIcon icon={faMapMarkerAlt as IconProp} size={'2x'} color={'green'} />
        </div>
        <div className={'to-and-from-rightcolumn'}>
          <div className={'to-and-from-heading'}>{load.dueOutCompany ?? na} </div>
          <div className={'to-and-from-text'}>{load.dueOutCity ?? na}, {load.dueOutState ?? na} </div>
          <div className={'to-and-from-text'}> {dueOutFormatted ?? na} </div>
        </div>
      </div>
      <div className={'to-and-from-row top-margin'}>
        <div className={'to-and-from-leftcolumn'}>
          <FontAwesomeIcon icon={faMapMarkerAlt as IconProp} size={'2x'} color={'red'} />
        </div>
        <div className={'to-and-from-rightcolumn'}>
          <div className={'to-and-from-heading'}> {load.firstAppointmentCompany ?? na} </div>
          <div className={'to-and-from-text'}> {load.firstAppointmentCity ?? na}, {load.firstAppointmentState ?? na} </div>
          <div className={'to-and-from-text'}> {firstAppointmentFormatted ?? na} </div>
        </div>
      </div>
    </div>
  );
}
